/**
 * Copyright (c) 2025-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Apache License 2.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const PresentationFill = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="M8 4a2 2 0 1 1-4 0 2 2 0 0 1 4 0M5 16v6H3V10a3 3 0 0 1 5.1-2.14l2.38 2.25 2.31-2.32 1.42 1.42-3.69 3.68L9 11.46V22H7v-6zm5-11h9v9h-9v2h4.37l2.82 6h2.2l-2.81-6H20a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H10z" />
  </Icon>
);
